import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { InputNilaiEkskulPage } from './input-nilai-ekskul.page';

const routes: Routes = [
  {
    path: '',
    component: InputNilaiEkskulPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [InputNilaiEkskulPage]
})
export class InputNilaiEkskulPageModule {}
